import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { adjuntarPactosATramite } from '../../services/pactoService';

/**
 * Junta los pactos que el operador emitió en el formulario de alta y los adjunta al trámite
 * una vez que este existe.
 *
 * El pacto se elige y se descarga ANTES del submit (ver SeccionGenerarPacto), cuando todavía
 * no hay idTramite, así que el adjunto queda diferido: la sección avisa con `registrarPacto` y
 * el formulario llama a `adjuntarATramite(id)` apenas nace el trámite. El hook vive acá y no
 * suelto en cada formulario porque son trece los que montan la sección.
 *
 * Uso:
 *
 *     const { registrarPacto, adjuntarATramite } = usePactosPendientes();
 *     ...
 *     <SeccionGenerarPacto cliente={clienteSeleccionado} onPactoGenerado={registrarPacto} />
 *     ...
 *     const creado = await crearTramiteX(payload);
 *     await adjuntarATramite(creado.idTramite);
 */
export default function usePactosPendientes() {
    const [pactos, setPactos] = useState([]);

    const registrarPacto = useCallback((pacto) => {
        setPactos((previos) => [...previos, pacto]);
    }, []);

    const adjuntarATramite = useCallback(async (idTramite) => {
        if (!idTramite || pactos.length === 0) {
            return;
        }
        try {
            await adjuntarPactosATramite(idTramite, pactos);
        } catch (error) {
            // El trámite YA se creó cuando esto corre: un error acá no puede tumbar el alta.
            // Se avisa y el operador vuelve a emitir el pacto cuando quiera.
            console.error('❌ Error adjuntando los pactos al trámite:', error);
            toast.warn('El trámite se creó, pero no se pudo adjuntar el PACTO.');
        }
    }, [pactos]);

    return { registrarPacto, adjuntarATramite };
}
